var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCashtabEncrypted = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#00abe6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m525 712.5v25c-13.805 0-25 11.184-25 25v150c0 13.816 11.195 25 25 25h150c13.805 0 25-11.184 25-25v-150c0-13.816-11.195-25-25-25v-25c0-41.359-33.641-75-75-75s-75 33.641-75 75zm125 175h-100v-100h100zm-25-175v25h-50v-25c0-13.793 11.219-25 25-25s25 11.207 25 25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1013.6 180.46c-18.691-11.145-40.262-17.965-63.559-17.965h-700c-23.297 0-44.867 6.8203-63.559 17.965l413.56 252.74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1052 215.5-439 268.25c-4 2.5-8.5 3.75-13 3.75s-9-1.25-13-3.75l-439-268.25c-14.25 20.5-23 45.25-23 72v400c0 0.5 0.25 0.75 0.25 1.25l310-221.25c11.25-8 26.75-5.5 34.75 5.75s5.5 26.75-5.75 34.75l-326.5 233.25c20 42 62.75 71.25 112.25 71.25h101.25c12.5 126 119.5 225 248.75 225s236.25-99 248.75-225h101.25c49.5 0 92.25-29.25 112.25-71.25l-326.5-233.25c-11.25-8-13.75-23.5-5.75-34.75s23.5-13.75 34.75-5.75l310 221.25c0-0.5 0.25-0.75 0.25-1.25v-400c0-26.75-8.75-51.5-23-72zm-252 572c0 8.5-0.5 16.75-1.5 25-12.5 98.5-96.75 175-198.5 175s-186-76.5-198.5-175c-1-8.25-1.5-16.5-1.5-25 0-110.25 89.75-200 200-200s200 89.75 200 200z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCashtabEncrypted);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cashtab-encrypted.9f53c765b44e6826c00f2472b5dfa35a.svg";